/**
 * Gives one owner to every storefront add-to-cart submission.
 *
 * Sellify is registered more than once at store level. Without this capture
 * guard, both registrations can process collection Quick Add, while a product
 * form can fall through to its native /cart action. Capture the shared Shopify
 * form contract before app/theme listeners, add exactly once, preserve VO
 * line-item properties in FormData, and then open Sellify's decorated trigger.
 */
(function () {
  const ADD_FORM_SELECTOR = 'form[data-type="add-to-cart-form"][action*="/cart/add"]';
  const pendingForms = new WeakSet();

  function cartUrl(path) {
    const root = window.Shopify?.routes?.root || '/';
    return `${root.replace(/\/$/, '')}${path}`;
  }

  function openSellify() {
    const sellifyTrigger = document.querySelector(
      'a.open-drawer, button.open-drawer, [data-ucd-open], [data-sellify-cart-open]'
    );

    if (sellifyTrigger instanceof HTMLElement) {
      sellifyTrigger.click();
      return true;
    }

    return false;
  }

  async function openSellifyOrCart() {
    for (let attempt = 0; attempt < 25; attempt += 1) {
      if (openSellify()) return;
      await new Promise((resolve) => window.setTimeout(resolve, 100));
    }

    window.location.assign(cartUrl('/cart'));
  }

  window.addEventListener(
    'click',
    function handleAddButtonClick(event) {
      const target = event.target;
      const button =
        target instanceof Element ? target.closest('button[type="submit"], input[type="submit"]') : null;
      const form = button?.form;
      if (!(form instanceof HTMLFormElement) || !form.matches(ADD_FORM_SELECTOR)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (pendingForms.has(form)) return;
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      form.requestSubmit(button);
    },
    true
  );

  window.addEventListener(
    'submit',
    async function handleProductSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches(ADD_FORM_SELECTOR)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (pendingForms.has(form) || !form.checkValidity()) return;
      pendingForms.add(form);

      const button =
        event.submitter instanceof HTMLButtonElement
          ? event.submitter
          : form.querySelector('[type="submit"]');
      if (button instanceof HTMLButtonElement) button.disabled = true;

      try {
        const response = await fetch(cartUrl('/cart/add.js'), {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });

        if (!response.ok) throw new Error(`Cart add failed: ${response.status}`);
        await response.json();

        document.dispatchEvent(
          new CustomEvent('dd:product-added-to-cart', {
            bubbles: true,
            detail: { source: form.closest('.quick-add') ? 'quick-add' : 'product-page' },
          })
        );
        await openSellifyOrCart();
      } catch (error) {
        console.error('[Dyke & Dean cart bridge]', error);
        window.location.assign(cartUrl('/cart'));
      } finally {
        pendingForms.delete(form);
        if (button instanceof HTMLButtonElement) button.disabled = false;
      }
    },
    true
  );
})();
